import { useEffect, useState } from "react";
import { api } from "./api";

let cache = {};
const listeners = new Set();

// Call after Terms Management mutations so every open form refetches fresh terms.
export function clearTermsCache() {
  cache = {};
  listeners.forEach((fn) => fn());
}

export function useTerms(postType, taxonomy, fallback = []) {
  const key = `${postType}:${taxonomy}`;
  const [terms, setTerms] = useState(cache[key] || fallback);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    const fn = () => setTick((t) => t + 1);
    listeners.add(fn);
    return () => listeners.delete(fn);
  }, []);

  useEffect(() => {
    if (!postType || !taxonomy) return;
    if (cache[key]) { setTerms(cache[key]); return; }
    api.get(`/terms?post_type=${postType}&taxonomy=${taxonomy}`)
      .then((r) => {
        const names = r.data.map((t) => t.name);
        if (names.length) { cache[key] = names; setTerms(names); }
      })
      .catch(() => {});
    // eslint-disable-next-line
  }, [key, tick]);
  return terms;
}
